<section class="section-div">
  <div>
    <div class="d-flex justify-content-between">
      <div class="header-div">
        <h4 *ngIf="role != 'CoE'">
          <ion-icon name="grid-outline"></ion-icon> Application Dashboard -
          {{ incubaterName }}
        </h4>
        <h4 *ngIf="role == 'CoE'">
          <ion-icon name="grid-outline"></ion-icon> {{ incubName }}
        </h4>
      </div>
      <div class="header-div ml-auto">
        <h6>
          Your Application Number :
          <span class="application-color">{{
            applicationNo || "Not Generated"
          }}</span>
        </h6>
      </div>
    </div>
    <div class="div-bg">
      <main>
        <div class="activity-container">
          <h6>No. of Questions Filled</h6>
          <div class="box-progress-wrapper">
            <p class="box-progress-header">
              Questions
              <span
                >({{ dashboardData.questionsfilled }}/{{
                  dashboardData.totalquestions
                }})</span
              >
            </p>
            <div class="box-progress-bar">
              <span
                class="box-progress"
                [style.width.%]="
                  (dashboardData.notImplemented /
                    dashboardData.totalquestions) *
                  100
                "
                style="background-color: #56c2e6"
              ></span>
            </div>
            <p class="box-progress-percentage">
              {{
                (dashboardData.questionsfilled / dashboardData.totalquestions) *
                  100 | number : "1.0-0"
              }}
              %
            </p>
          </div>
        </div>
        <div class="activity-container">
          <h6>Application Submission Status</h6>
          <div class="box-progress-wrapper">
            <p class="box-progress-header">
              <span *ngIf="dashboardData.status == 0">Pending</span>
              <span *ngIf="dashboardData.status == 1">Submitted</span>
              <span *ngIf="dashboardData.status == 2"
                >Process Verification</span
              >
              <span *ngIf="dashboardData.status == 3">Under Clarification</span>
              <span *ngIf="dashboardData.status == 4">Approved</span>
              <span *ngIf="dashboardData.status == 5">Reject</span>
              <span *ngIf="dashboardData.status == 6"
                >Clarification Submitted</span
              >
              <span *ngIf="dashboardData.status == 7"
                >Process Verificiation Pending</span
              >
            </p>
          </div>
        </div>
        <div class="activity-container">
          <h6>
            Remarks
            <span *ngIf="dashboardData.showBellIcon == true"
              ><img
                src="/assets/images/notification-bell-unscreen.gif"
                alt=""
                style="width: 25px"
            /></span>
          </h6>
          <p class="box-progress-header">
            <span>
              <a
                class="Clarification2-btn ml-3"
                (click)="History(dashboardData.applicationId)"
                >View</a
              >
            </span>
          </p>
          <div class="box-progress-wrapper"></div>
        </div>
      </main>
      <div
        *ngIf="
          (role == 'Admin' && dashboardData.status == 1) ||
          (role == 'Admin' && dashboardData.status == 7)
        "
        class="text-center"
      >
        <button class="approval-btn" (click)="Verfication('2')">
          Process Verification
        </button>
        <button class="Clarification-btn ml-3" (click)="Clarification('3')">
          More Clarification
        </button>
      </div>
      <div
        *ngIf="
          (role == 'Admin' && dashboardData.status == 6) ||
          dashboardData.status == 3
        "
        class="text-center"
      >
        <button class="approval-btn" (click)="Verfication('7')">
          Close Clarification
        </button>
      </div>
      <div
        *ngIf="role == 'Admin' && dashboardData.status == 2"
        class="text-center"
      >
        <button class="approval-btn" (click)="Verfication('4')">Approve</button>
        <button class="Clarification-btn ml-3" (click)="Clarification('5')">
          Reject
        </button>
      </div>
    </div>
  </div>
</section>

<div class="modal-con">
  <div
    class="modal fade"
    id="Verfication"
    data-backdrop="static"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="incubatee-div-modal">
          <div>
            <h3>Confirm</h3>
          </div>
          <div class="text-center mt-3">
            <button mat-raised-button color="warn">Logout</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="coeModal" class="modal" style="position: absolute">
  <div
    class="modal-content text-center"
    style="width: 90%; max-height: 70vh; overflow-y: auto"
  >
    <div>
      <table class="table" *ngIf="noData == false">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Action</th>
            <th scope="col" class="text-center">Date & Time</th>
            <th scope="col">Remark</th>
            <th scope="col" class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let list of historyData; let i = index">
            <th scope="row">{{ i + 1 }}</th>
            <td>{{ list.activity }}</td>
            <td class="text-center">{{ list.createdTime }}</td>
            <td *ngIf="list.remarks">{{ list.remarks }}</td>
            <td *ngIf="!list.remarks">-</td>
            <td class="text-center">
              <span *ngIf="list.resolved == true">Resolved</span>
              <span *ngIf="list.resolved == false">Unresolved</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center no-data-div" *ngIf="noData == true">
        <img src="assets/images/startup-logo.png" class="img-fluid" alt="" />
        <h6>No Remarks Found</h6>
      </div>
      <div class="text-center mt-5">
        <button
          class="mr-2"
          mat-raised-button
          color="warn"
          (click)="closeModal()"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
